module.exports = __webpack_public_path__ + "img/icon-genders.a4cca82d.svg";